import React, { useEffect, useState } from "react";
import AppNavbar from "../../components/common/AppNavbar";
import { fetchNewsByCategory } from "../../services/api";
import Loading from "../../components/common/Loading";
import NewsSection from "../../components/home/NewsSection";
import { Helmet } from "react-helmet";

function Auto() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      const data = await fetchNewsByCategory("auto");
      setNews(data);
      setLoading(false);
    }
    load();
  }, []);

  if (loading) return <Loading />;

  return (
    <>
      <Helmet>
        <title>
          Auto News | Car, Bike & EV Updates, Reviews, Prices – BharatAbroad
        </title>
        <meta
          name="description"
          content="Stay updated with the latest auto news, including new car and bike launches, EV updates, prices, reviews, specs, and automobile industry trends on BharatAbroad."
        />
        <meta
          name="keywords"
          content="global auto news, world car news, international bike news, automobile industry news, latest car launches worldwide, new bike launches global, electric vehicle news global, EV market worldwide, global car reviews, international bike reviews, best cars in the world, top bikes worldwide, SUV market global, electric scooter news global, EV charging infrastructure worldwide, EV battery technology global, automobile comparison global, car vs bike comparison worldwide, auto industry trends global, auto news, car news, bike news, automobile news, latest car updates, latest bike updates, EV news, electric vehicles, automobile updates today, auto industry news, latest car news today, new bike launch today, electric car news, EV bike launch, auto news today, upcoming cars 2026, new bike launch 2026, automobile breaking news, new cars, upcoming cars, car price, car review, best cars, SUV cars, electric cars, car mileage, car specifications, budget cars, new bikes, upcoming bikes, bike price, bike review, best bikes, electric bikes, sports bike, mileage bikes, 350cc bikes, commuter bikes, electric vehicle, EV bike, EV car, electric scooter, EV charging stations, EV range and battery, electric bike range, EV price, electric mobility, best electric bikes 2026, upcoming electric cars 2026, car price and specs, bike review and mileage, latest EV news today, new bike launch price and features, best budget cars 2026, electric scooter price and range, car review and specs, bike review and features, automobile comparison, car vs bike comparison, top cars, top bikes, auto launch news, vehicle performance review, BharatAbroad auto news, BharatAbroad car news, BharatAbroad bike updates, BharatAbroad EV news, BharatAbroad automobile"
        />

        {/* Technical */}
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta charSet="UTF-8" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Auto News | Car, Bike & EV Updates, Reviews, Prices – BharatAbroad"
        />
        <meta
          property="og:description"
          content="Get the latest auto news, car and bike launches, EV updates, reviews, prices, specs, and automobile industry trends on BharatAbroad."
        />
        <meta property="og:site_name" content="BharatAbroad" />
        <meta property="og:url" content="https://www.bharatabroad.com/auto" />
        <meta
          property="og:image"
          content="https://ayg.s3.us-east-2.amazonaws.com/www.bharatabroad.com+-+2026-05-08T104629.344.png"
        />

        {/* Canonical */}
        <link rel="canonical" href="https://www.bharatabroad.com/auto" />
      </Helmet>
      <AppNavbar />
      <div style={{ padding: "20px" }}>
        <div id="container">
          <NewsSection title="Auto News" articles={news} category="auto" />
        </div>
      </div>
    </>
  );
}

export default Auto;
